import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const SettingsAlt24 = (props: SvgIconProps): JSX.Element => React.createElement(SvgIcon, props, <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M11 16V5a1 1 0 0 1 2 0v11h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0v-1h-1a1 1 0 0 1 0-2h1Zm7-10V5a1 1 0 0 1 2 0v1h1a1 1 0 1 1 0 2h-1v11a1 1 0 0 1-2 0V8h-1a1 1 0 1 1 0-2h1ZM6 9h1a1 1 0 0 1 0 2H6v8a1 1 0 1 1-2 0v-8H3a1 1 0 0 1 0-2h1V5a1 1 0 0 1 2 0v4Z' /></svg>);
